import makeStyles from "@mui/styles/makeStyles";

import { relativeFills } from "utils/relativeUtils";

export default makeStyles(
  (theme) => ({
    root: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 0,
      margin: "0 auto",
      alignSelf: "center",
      "&:hover": {
        opacity: 0.5,
      },
    },
    noOpacity: {
      "&:hover": {
        opacity: 1,
      },
    },
    extended: {
      width: "70%",
      maxWidth: 260,
      [theme.breakpoints.up("mobile")]: {
        width: 260,
      },
      [theme.breakpoints.up("tablet")]: {
        width: "100%",
      },
    },
    badge: {
      width: 24,
      height: 24,
      right: "calc(50% - 29px)",
      top: 0,
      position: "absolute",
      borderRadius: "50%",
      border: [2, "solid", theme.palette.primary.light],
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      [theme.breakpoints.up("mobile")]: {
        right: "calc(50% - 43px)",
        width: 31.1,
        height: 31.1,
      },
    },
    blueBadge: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.light,
      "&:hover": {
        color: theme.palette.cornflowerBlue,
        transform: "scale(1.1)",
      },
    },
    greenBadge: {
      backgroundColor: "white",
      border: `7px solid ${theme.palette.springGreen}`,
      color: theme.palette.springGreen,
    },
    partyHat: {
      position: "relative",
      height: 56,
      left: 8,
      top: 10,
      zIndex: 999,
      [theme.breakpoints.up("mobile")]: {
        height: 58,
        left: 16,
      },
    },
    decor: {
      position: "absolute",
      zIndex: 999,
    },
    balloon: {
      width: 35,
      height: 78,
      [theme.breakpoints.up("mobile")]: {
        width: 40,
        height: 90,
      },
      [theme.breakpoints.up("tablet")]: {
        width: 46,
        height: 101,
      },
    },
    bigHeart: {
      width: 36,
      height: 36,
      [theme.breakpoints.up("mobile")]: {
        width: 46,
        height: 46,
      },
    },
    smallHeart: {
      width: 29,
      height: 29,
      [theme.breakpoints.up("mobile")]: {
        width: 37,
        height: 37,
      },
    },
    flowerBouquet: {
      width: 62,
      height: 62,
      [theme.breakpoints.up("mobile")]: {
        width: 69,
        height: 69,
      },
    },
    flower: {
      width: 37,
      height: 37,
      [theme.breakpoints.up("mobile")]: {
        width: 46,
        height: 46,
      },
    },
    fatherHat: {
      position: "relative",
      height: 42,
      left: 6,
      top: 14,
      zIndex: 999,
      [theme.breakpoints.up("mobile")]: {
        height: 58,
        top: 17,
        left: 12,
      },
    },
    blueBalloon: {
      right: "-33px!important",
      [theme.breakpoints.up("mobile")]: {
        right: -16,
      },
    },
    ...relativeFills(theme),
  }),
  { name: "DisplayPerson" },
);
